<template>
  <div>
    <el-form
      :disabled="disabled"
      :model="form"
      ref="RefForm"
      label-position="right"
      size="small"
      label-width="80px"
      :rules="rules"
    >
      <el-row :gutter="20" class="form-item-row">
        <el-col :span="24">
          <el-form-item
            :label="this.$l('form_label_state') || '状态'"
            prop="pdTechDictStatus"
          >
            <el-radio-group v-model="form.pdTechDictStatus">
              <el-radio label="Y">{{
                $l('form_label_effective') || '有效'
              }}</el-radio>
              <el-radio label="N">{{
                $l('form_label_vitiation') || '无效'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="form-item-row">
        <el-col :span="24">
          <el-form-item
            :label="this.$l('form_label_processName') || '工艺名称'"
            prop="techName"
          >
            <el-input
              placeholder="请输入内容"
              v-model="form.techName"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="form-item-row">
        <el-col :span="12">
          <el-form-item
            :label="this.$l('form_label_productionProcesses') || '工序'"
            prop="pdProcessDictStep"
          >
            <dict-select
              v-model="form.pdProcessDictStep"
              url="/master/common/dict/biz"
              :body="{ dictType: 'pdProcessDictStep' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="small"
              style="width: 100%"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" class="form-item-row">
          <el-form-item
            :label="this.$l('form_label_techChargeUnit ') || '计价单位'"
            prop="techChargeUnit"
          >
            <dict-select
              v-model="form.techChargeUnit"
              url="/master/common/dict/biz"
              :body="{ dictType: 'techChargeUnit' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="small"
              style="width: 100%"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="form-item-row" v-if="disabled">
        <el-col :span="12">
          <el-form-item
            :label="this.$l('INDEX.create_date') || '创建时间'"
            prop="techName"
          >
            <el-input v-model="form.createTime" clearable> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="
              this.$l('INDEX.table_label_modification_date') || '修改时间'
            "
            prop="techName"
          >
            <el-input v-model="form.modifyTime" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    pdTechDictCode: {
      type: String,
      default: '',
    },
  },
  watch: {
    pdTechDictCode: function() {
      this.getData()
    },
  },
  mounted() {
    this.getData()
  },
  data() {
    return {
      form: {
        pdTechDictStatus: 'Y',
      },
      loading: '',
      rules: {
        techName: [
          { required: true, message: '工艺名称不能为空', trigger: 'blur' },
        ],
        pdProcessDictStep: [
          { required: true, message: '工序不能为空', trigger: 'change' },
        ],
        pdTechDictStatus: [
          { required: true, message: '状态不能为空', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    getData() {
      if (!this.pdTechDictCode) {
        this.form = { pdTechDictStatus: 'Y' }
        return
      }
      this.$api
        .pdTechDictionaryDetailApi({
          pdTechDictCode: this.pdTechDictCode,
        })
        .then((res) => {
          this.form = res.body
        })
    },
    save() {
      this.$refs['RefForm'].validate((valid) => {
        if (valid) {
          this.loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          })
          this.$api
            .pdTechDictionarySaveApi({ ...this.form })
            .then((res) => {
              if (res.status == 200) {
                this.$message({
                  message: '保存成功',
                  type: 'success',
                })
                this.form = { pdTechDictStatus: 'Y' }
              } else {
                this.$message.error(res.message)
              }
              this.$emit('closeEdit')
            })
            .finally(() => {
              this.loading.close()
            })
        } else {
          return false
        }
      })
    },
  },
}
</script>
<style scoped>
.form-item-row {
  margin-bottom: 10px;
}
.form-item-row:last-child {
  margin-bottom: 5px;
}
</style>
